'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isTrivialHref = function isTrivialHref(href) {
    return !href || href.trim() === '#';
};

var Anchor = (_temp2 = _class = function (_PureComponent) {
    _inherits(Anchor, _PureComponent);

    function Anchor() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Anchor);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Anchor.__proto__ || Object.getPrototypeOf(Anchor)).call.apply(_ref, [this].concat(args))), _this), _this.actions = {
            handleClick: function handleClick(event) {
                var _this$props = _this.props,
                    disabled = _this$props.disabled,
                    href = _this$props.href,
                    onClick = _this$props.onClick;


                if (disabled || isTrivialHref(href)) {
                    event.preventDefault();
                }

                if (disabled) {
                    event.stopPropagation();
                    return;
                }

                if (onClick) {
                    onClick(event);
                }
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Anchor, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                href = _props.href,
                role = _props.role,
                tabIndex = _props.tabIndex,
                componentClass = _props.componentClass,
                style = _props.style,
                props = _objectWithoutProperties(_props, ['href', 'role', 'tabIndex', 'componentClass', 'style']);

            var Component = componentClass || 'a';

            if (isTrivialHref(href)) {
                role = role || 'button';
                href = href || '';
            }

            if (this.props.disabled) {
                tabIndex = -1;
                style = _extends({
                    pointerEvents: 'none'
                }, style);
            }

            return _react2.default.createElement(Component, _extends({}, props, {
                role: role,
                href: href,
                style: style,
                tabIndex: tabIndex,
                onClick: this.actions.handleClick
            }));
        }
    }]);

    return Anchor;
}(_react.PureComponent), _class.propTypes = {
    componentClass: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
    disabled: _propTypes2.default.bool,
    href: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    role: _propTypes2.default.string,
    style: _propTypes2.default.object,
    tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
}, _class.defaultProps = {
    componentClass: 'a'
}, _temp2);
exports.default = Anchor;


//////////////////
// WEBPACK FOOTER
// ./~/@trendmicro/react-anchor/lib/Anchor.js
// module id = 940
// module chunks = 0